import * as orderServices from '../services/order';
import { handleError } from '../utils/error';
import * as orderConstants from '../Constants/orderConstants';
import * as cartConstants from '../Constants/cartConstants';

export const createOrder = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: orderConstants.CREATE_ORDER_START });

    const { data } = await orderServices.createOrder(orderData);

    dispatch({
      type: orderConstants.CREATE_ORDER_SUCCESS,
      payload: data,
    });
    localStorage.removeItem('cartItems');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('cartAreas');
    // localStorage.removeItem('paymentMethod');
    dispatch({
      type: cartConstants.CART_RESET,
    });
  } catch (err) {
    dispatch({
      type: orderConstants.CREATE_ORDER_FAIL,
      payload: handleError(err),
    });
  }
};

export const getOrder = (orderId, initialLoading) => async (dispatch) => {
  try {
    if (initialLoading) {
      dispatch({ type: orderConstants.GET_ORDER_START });
    }

    const { data } = await orderServices.order(orderId);

    dispatch({
      type: orderConstants.GET_ORDER_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: orderConstants.GET_ORDER_FAIL,
      payload: handleError(err),
    });
  }
};

export const approveOrder = (orderId) => async (dispatch) => {
  try {
    dispatch({
      type: orderConstants.ORDER_APPROVED_START,
    });

    const { data } = await orderServices.approveOrder(orderId);

    dispatch({
      type: orderConstants.ORDER_APPROVED_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: orderConstants.ORDER_APPROVED_FAIL,
      payload: handleError(err),
    });
  }
};

export const cancelOrder = (orderId) => async (dispatch) => {
  try {
    dispatch({
      type: orderConstants.ORDER_CANCELLED_START,
    });

    const { data } = await orderServices.cancelOrder(orderId);

    dispatch({
      type: orderConstants.ORDER_CANCELLED_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: orderConstants.ORDER_CANCELLED_FAIL,
      payload: handleError(err),
    });
  }
};

export const payOrder = (orderId) => async (dispatch) => {
  try {
    dispatch({
      type: orderConstants.ORDER_PAID_START,
    });

    const { data } = await orderServices.payOrder(orderId);

    dispatch({
      type: orderConstants.ORDER_PAID_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: orderConstants.ORDER_PAID_FAIL,
      payload: handleError(err),
    });
  }
};

export const deliverOrder = (orderId) => async (dispatch) => {
  try {
    dispatch({
      type: orderConstants.ORDER_DILIVERD_START,
    });

    const { data } = await orderServices.deliverOrder(orderId);

    dispatch({
      type: orderConstants.ORDER_DILIVERD_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: orderConstants.ORDER_DILIVERD_FAIL,
      payload: handleError(err),
    });
  }
};

export const authOrder = () => async (dispatch) => {
  try {
    dispatch({
      type: orderConstants.AUTH_ORDER_FETCH_START,
    });

    const { data, count } = await orderServices.userOrder();

    dispatch({
      type: orderConstants.AUTH_ORDER_FETCH_SUCCESS,
      payload: data,
      total: count,
    });
  } catch (err) {
    dispatch({
      type: orderConstants.AUTH_ORDER_FETCH_FAIL,
      payload: handleError(err),
    });
  }
};

export const listOrders = () => async (dispatch) => {
  try {
    dispatch({
      type: orderConstants.ORDERLIST_FETCH_START,
    });

    const { results, count } = await orderServices.orders();

    dispatch({
      type: orderConstants.ORDERLIST_FETCH_SUCCESS,
      payload: {
        results,
        count,
      },
    });
  } catch (err) {
    dispatch({
      type: orderConstants.ORDERLIST_FETCH_FAIL,
      payload: handleError(err),
    });
  }
};

export const deleteOrder = (id) => async (dispatch) => {
  try {
    dispatch({ type: orderConstants.DELETE_ORDER_START });

    await orderServices.deleteOrder(id);

    dispatch({
      type: orderConstants.DELETE_ORDER_SUCCESS,
    });
  } catch (err) {
    dispatch({
      type: orderConstants.DELETE_ORDER_FAIL,
      payload: handleError(err),
    });
  }
};
